import React from 'react';

import FormGroup from '~/commons/components/FormGroup.jsx';

import FieldArrayCards from '../FieldArrayCards.jsx';

const arrDefaults = {
  extraItems: {
    description: '',
    price: 0,
  },
};

const FieldExtraItemsCards = ({
  extraItems = arrDefaults.extraItems,
  keyID = 'extraItems',
  disabled,
}) => (
  <div className="row">
    <div className="col">
      <FieldArrayCards name={keyID} push={disabled ? undefined : extraItems} disabled={disabled}>
        {(s, i) => (
          <>
            <div className="row">
              <div className="col">
                <FormGroup
                  name={`${keyID}[${i}].description`}
                  label="Description"
                  disabled={disabled}
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <FormGroup
                  name={`${keyID}[${i}].price`}
                  type="number"
                  label="Price"
                  disabled={disabled}
                />
              </div>
            </div>
          </>
        )}
      </FieldArrayCards>
    </div>
  </div>
);

export default FieldExtraItemsCards;
